import { useState } from "react";
import { tokenizeHtml } from "../hl";
import { page } from "../page-copy";
import { revealHostProps } from "../reveal-host";

function CliLine({ text }: { text: string }) {
  return (
    <pre
      className="adapters-cli"
      aria-label="Example command"
      dangerouslySetInnerHTML={{ __html: tokenizeHtml(text) }}
    />
  );
}

/** Compile React components → adapters for non-React stacks. */
export default function Adapters({ delay }: { delay: number }) {
  const { adapters } = page;
  const stacks = adapters.stacks;
  const [active, setActive] = useState(stacks[0].key);
  const pane = stacks.find((s) => s.key === active) ?? stacks[0];
  const reveal = revealHostProps(delay);

  return (
    <div
      className={`${reveal.className} adapters`}
      style={reveal.style}
      onAnimationEnd={reveal.onAnimationEnd}
    >
      <h2 className="adapters-heading">
        <span className="adapters-heading-primary">{adapters.heading.primary}</span>{" "}
        <span className="adapters-heading-secondary">
          {adapters.heading.secondary}
        </span>
      </h2>
      <p className="adapters-lead">{adapters.lead}</p>

      <div className="flow-diagram flow-diagram--hero">
        <div className="flow-node" aria-hidden="true">
          {adapters.source}
        </div>
        <div className="flow-rail" aria-hidden="true" />
        <CliLine text={adapters.cli} />
        <div className="flow-rail" aria-hidden="true" />
        <div className="flow-node flow-node--out" aria-hidden="true">
          {adapters.output}
        </div>
        <div className="flow-rail" aria-hidden="true" />
        <div className="flow-fan" role="tablist" aria-label="Adapter targets">
          <button
            type="button"
            role="tab"
            className="flow-fan-item"
            aria-selected={active === "wc"}
            data-active={active === "wc" ? "" : undefined}
            onMouseEnter={() => setActive("wc")}
            onFocus={() => setActive("wc")}
            onClick={() => setActive("wc")}
          >
            Web Component
          </button>
          <button
            type="button"
            role="tab"
            className="flow-fan-item"
            aria-selected={active === "blade"}
            data-active={active === "blade" ? "" : undefined}
            onMouseEnter={() => setActive("blade")}
            onFocus={() => setActive("blade")}
            onClick={() => setActive("blade")}
          >
            Laravel Blade
          </button>
          <button
            type="button"
            role="tab"
            className="flow-fan-item"
            aria-selected={active === "rails"}
            data-active={active === "rails" ? "" : undefined}
            onMouseEnter={() => setActive("rails")}
            onFocus={() => setActive("rails")}
            onClick={() => setActive("rails")}
          >
            Rails
          </button>
          <button
            type="button"
            role="tab"
            className="flow-fan-item"
            aria-selected={active === "alpine"}
            data-active={active === "alpine" ? "" : undefined}
            onMouseEnter={() => setActive("alpine")}
            onFocus={() => setActive("alpine")}
            onClick={() => setActive("alpine")}
          >
            Alpine
          </button>
          <button
            type="button"
            role="tab"
            className="flow-fan-item"
            aria-selected={active === "astro"}
            data-active={active === "astro" ? "" : undefined}
            onMouseEnter={() => setActive("astro")}
            onFocus={() => setActive("astro")}
            onClick={() => setActive("astro")}
          >
            Astro
          </button>
          <button
            type="button"
            role="tab"
            className="flow-fan-item"
            aria-selected={active === "html"}
            data-active={active === "html" ? "" : undefined}
            onMouseEnter={() => setActive("html")}
            onFocus={() => setActive("html")}
            onClick={() => setActive("html")}
          >
            Plain JS
          </button>
        </div>
      </div>

      <div className="stack-pane">
        <div className="stack-title">{pane.title}</div>
        <pre
          className="code-mini"
          dangerouslySetInnerHTML={{ __html: tokenizeHtml(pane.code) }}
        />
      </div>
    </div>
  );
}
